import isMobile from './isMobile';

export default () => (isMobile.any() ? 'MOBILE' : 'DESKTOP');
